'use strict';

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const PerfectScrollbar=require('perfect-scrollbar');
const BaseDirective=require('../../../../dist-es6/client/angularCommon/baseDirective');

const Options=[
'wheelSpeed','wheelPropagation','minScrollbarLength','maxScrollbarLength',
'useBothWheelAxes','useKeyboard','suppressScrollX','suppressScrollY',
'scrollXMarginOffset','scrollYMarginOffset','includePadding'];let


ScrollbarDirective=class ScrollbarDirective extends BaseDirective{
get restrict(){
return'EA';
}

get objectBindings(){
return['useSidebarService','onScroll','refreshOnChange'];
}

get textBindings(){
return Options;
}

get templateUrl(){
return'/templates/directives/scrollbarDirective/scrollbarTemplate';
}

factory($parse,$window,$timeout,sidebarScrollingService){
const directive=super.factory();
const _window=angular.element($window);

directive.transclude=!0;
directive.replace=!0;

directive.link=($scope,$element,$attr)=>{
if($scope.useSidebarService){
$scope.$on('$destroy',()=>{
sidebarScrollingService.reset();
});
}

const _element=$element[0];
const options={};
let _scrollbar;


Options.filter(opt=>_.exists($attr[opt])).forEach(opt=>{
options[opt]=$parse($attr[opt])();
});

if($scope.useSidebarService){
sidebarScrollingService.preventAutoScroll=!0;
}

let onScrollEventHandler;
$scope.$evalAsync(()=>{
if($scope.useSidebarService){
sidebarScrollingService.preventAutoScroll=!1;
sidebarScrollingService.immediatelyJumpToLastPosition();
}
_scrollbar=new PerfectScrollbar(_element,options);

const hasOnScrollHandler=_.exists($scope.onScroll)||_.exists($attr.onScroll)&&$attr.onScroll!=='';
if(!($scope.useSidebarService||hasOnScrollHandler)){
return;
}

const onScrollHandler=hasOnScrollHandler?$parse($scope.onScroll||$attr.onScroll):null;
const processScrollEvent=()=>{
fastdom.measure(()=>{
let scrollTop=$element.scrollTop();
let scrollHeight=hasOnScrollHandler?$element.prop('scrollHeight')-$element.height():null;
if(hasOnScrollHandler){
onScrollHandler($scope,{scrollTop,scrollHeight});
}

if($scope.useSidebarService){
sidebarScrollingService.updateLastPosition(scrollTop);
}
});
};

onScrollEventHandler=processScrollEvent;

$element.scroll(onScrollEventHandler);
});

const _scrollTop=()=>fastdom.mutate(()=>$($element).scrollTop($($element).prop('scrollHeight')));
const _update=event=>{
if(!_scrollbar){
return;
}

if($attr.scrollDown==='true'&&event!=='mouseenter'){
$timeout(_scrollTop,100);
}
_scrollbar.update(_element);
};

const update=event=>_update(event);


$element.bind('mouseenter',()=>update('mouseenter'));


if($attr.refreshOnChange){
$scope.$watchCollection(()=>$scope.refreshOnChange,(newVal,oldVal)=>{
if(_.isEqual(oldVal,newVal)){
return;
}

update('refreshOnChange');
});
}


if($attr.refreshOnResize){
_window.on('resize',update);
}

$element.bind('$destroy',()=>{
if($attr.refreshOnResize){
_window.off('resize',update);
}
if(_.exists(onScrollEventHandler)){
$element.off('scroll',onScrollEventHandler);
}
if(_scrollbar){
_scrollbar.destroy(_element);
_scrollbar=null;
}
});
};

return directive;
}};



module.exports=ScrollbarDirective;
module.exports.prototype.factory.$inject=['$parse','$window','$timeout','sidebarScrollingService'];
//# sourceMappingURL=scrollbarDirective.js.map
